<div class="card">
  <app-header titulo="Configuração de Análise de Pesagem" descricao="Gerencie os tipos de análise cadastrados para o processo de pesagem."></app-header>

  <!-- Tabela -->
  <p-table
    #dtanalisepesagem
    [value]="tiposAnalise"
    [loading]="loading"
    [globalFilterFields]="['codigo', 'descricao', 'instancia']"
    dataKey="id"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
    [rowsPerPageOptions]="[10, 20, 50]"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
    [scrollable]="true"
    scrollHeight="40.5rem"
  >
    <ng-template pTemplate="caption">
      <div class="flex justify-content-end flex-wrap">
        <div class="flex align-items-center justify-content-center">
          <p-button label="Novo Tipo de Análise" icon="pi pi-plus" severity="success" (onClick)="abrirNovo()"></p-button>
        </div>
        <div class="flex align-items-center justify-content-center">
          <span class="p-input-icon-left ml-auto">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dtanalisepesagem.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
          </span>
        </div>
        <div class="flex align-items-center justify-content-center">
          <p-button icon="pi pi-refresh" [rounded]="true" [text]="true" severity="secondary" styleClass="ml-3" (onClick)="carregarTiposAnalise()" [loading]="loading" pTooltip="Atualizar" tooltipPosition="top"></p-button>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="instancia">
          Instância <p-sortIcon field="instancia"></p-sortIcon>
          <p-columnFilter field="instancia" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" [showApplyButton]="false" [showClearButton]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-multiSelect [ngModel]="value" [options]="opcoesInstancia" (onChange)="filter($event.value)" placeholder="Selecionar..." [showClear]="true" [filter]="true" [style]="{'min-width': '14rem'}"></p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </th>
        <th>Código</th>
        <th>Descrição</th>
        <th>Status</th>
        <th pFrozenColumn alignFrozen="right" style="min-width: 90px; text-align: center;">Ações</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-tipoAnalise>
      <tr>
        <td>
          <p-tag *ngIf="tipoAnalise.instancia" [value]="tipoAnalise.instancia" severity="secondary" [rounded]="true" styleClass="text-xs"></p-tag>
          <span *ngIf="!tipoAnalise.instancia" class="text-400">—</span>
        </td>
        <td>
          <span class="font-semibold text-900">{{ tipoAnalise.codigo }}</span>
        </td>
        <td>
          <span class="text-700">{{ tipoAnalise.descricao || '—' }}</span>
        </td>
        <td>
          <p-tag
            [value]="tipoAnalise.ativo ? 'Ativo' : 'Inativo'"
            [severity]="tipoAnalise.ativo ? 'success' : 'warning'"
            [rounded]="true"
            [icon]="tipoAnalise.ativo ? 'pi pi-check-circle' : 'pi pi-minus-circle'"
          ></p-tag>
        </td>
        <td pFrozenColumn alignFrozen="right" style="text-align: center;">
          <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="info" (onClick)="abrirEditar(tipoAnalise)" pTooltip="Editar tipo de análise" tooltipPosition="top"></p-button>
          <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" (onClick)="confirmarExclusao(tipoAnalise, $event)" pTooltip="Excluir tipo de análise" tooltipPosition="top"></p-button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">
          <div class="flex flex-column align-items-center justify-content-center py-5">
            <i class="pi pi-inbox text-4xl text-300 mb-3"></i>
            <span class="text-500 font-medium">Nenhum tipo de análise cadastrado.</span>
            <span class="text-400 text-sm mt-1">Clique em "Novo Tipo de Análise" para começar.</span>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Dialog de Criar/Editar -->
<p-dialog
  [header]="editando ? 'Editar Tipo de Análise' : 'Novo Tipo de Análise'"
  [(visible)]="displayDialog"
  [modal]="true"
  [style]="{ width: '560px' }"
  [closable]="true"
  (onHide)="fecharDialog()"
  styleClass="dialog-analisepesagem"
>
  <!-- Seção: Identificação -->
  <div class="mb-4">
    <div class="flex align-items-center gap-2 mb-3">
      <i class="pi pi-id-card text-primary"></i>
      <span class="text-900 font-semibold text-lg">Identificação</span>
    </div>
    <div class="grid p-fluid">
      <div class="col-12 field">
        <label class="font-medium text-800">Instância <span *ngIf="!editando" class="text-red-500">*</span></label>
        <app-empresa-dropdown *ngIf="!editando" modo="unico" [(selecionadas)]="tipoAnaliseSelecionado.instancia!"></app-empresa-dropdown>
        <input *ngIf="editando" pInputText [value]="tipoAnaliseSelecionado.instancia" [disabled]="true" class="w-full" />
      </div>
      <div class="col-12 md:col-6 field">
        <label for="codigo" class="font-medium text-800">Código <span class="text-red-500">*</span></label>
        <p-dropdown [options]="codigosAnalise" [(ngModel)]="tipoAnaliseSelecionado.codigo" placeholder="Selecione o código" appendTo="body" [disabled]="editando"></p-dropdown>
      </div>
      <div class="col-12 md:col-6 field flex align-items-end">
        <div class="w-full">
          <label class="font-medium text-800 block mb-2">Status</label>
          <p-toggleButton
            [(ngModel)]="tipoAnaliseSelecionado.ativo"
            [onLabel]="'Ativo'"
            [offLabel]="'Inativo'"
            [onIcon]="'pi pi-check'"
            [offIcon]="'pi pi-times'"
            styleClass="w-full border-round-lg"
          ></p-toggleButton>
        </div>
      </div>
      <div class="col-12 field">
        <label for="descricao" class="font-medium text-800">Descrição</label>
        <textarea id="descricao" pInputTextarea rows="3" [(ngModel)]="tipoAnaliseSelecionado.descricao" placeholder="Descrição do tipo de análise..." class="border-round-lg"></textarea>
      </div>
    </div>
  </div>

  <!-- Info de auditoria (só no modo edição) -->
  <div *ngIf="editando && tipoAnaliseSelecionado.created_at" class="surface-ground border-round-lg p-3 mt-2">
    <div class="flex align-items-center gap-2 mb-2">
      <i class="pi pi-info-circle text-500 text-sm"></i>
      <span class="text-500 font-medium text-sm">Informações de Auditoria</span>
    </div>
    <div class="grid">
      <div class="col-6">
        <span class="text-400 text-xs block">Criado em</span>
        <span class="text-700 text-sm">{{ tipoAnaliseSelecionado.created_at | date:'dd/MM/yyyy HH:mm' }}</span>
      </div>
      <div class="col-6">
        <span class="text-400 text-xs block">Última atualização</span>
        <span class="text-700 text-sm">{{ tipoAnaliseSelecionado.updated_at | date:'dd/MM/yyyy HH:mm' }}</span>
      </div>
      <div class="col-6" *ngIf="tipoAnaliseSelecionado.created_by">
        <span class="text-400 text-xs block">Criado por</span>
        <span class="text-700 text-sm">{{ tipoAnaliseSelecionado.created_by }}</span>
      </div>
      <div class="col-6" *ngIf="tipoAnaliseSelecionado.updated_by">
        <span class="text-400 text-xs block">Atualizado por</span>
        <span class="text-700 text-sm">{{ tipoAnaliseSelecionado.updated_by }}</span>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button label="Cancelar" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="fecharDialog()" styleClass="border-round-lg"></p-button>
      <p-button label="Salvar" icon="pi pi-check" (onClick)="salvar()" [loading]="loadingSalvar" styleClass="border-round-lg"></p-button>
    </div>
  </ng-template>
</p-dialog>

<p-confirmDialog styleClass="border-round-xl"></p-confirmDialog>
